import PrintProductSizeRoesConfigurator from './PrintProductSizeRoesConfigurator';
import withModal from '../../../../../../../../../../../components/global/modal/withModal';

export const PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_MODAL =
  'modal/PRINT_PRODUCT_ROES_CONFIGURATOR';

export default withModal(PrintProductSizeRoesConfigurator, {
  name: PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
});
